function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFAF20",
  strokeLinejoin: "round",
  d: "M6 24v-5.792C6 9.808 12.711 3 20.997 3 29.28 3 36 9.809 36 18.208V24"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFAF20",
  strokeLinejoin: "round",
  d: "M29 16c-5.09-1.82-10.91-1.82-16 0v-5.635c5.09-1.82 10.91-1.82 16 0V16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAF20",
  d: "M21 0a2 2 0 0 0-2 2h4c0-1.104-.897-2-2-2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFAF20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M38 32c-4.455-3.037-10.617-4.125-16.5-4.125-5.884 0-12.046 1.089-16.5 4.125l1.435-7.602C10.967 22.224 16.084 21 21.5 21c5.412 0 10.53 1.224 15.065 3.398L38 32z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFAF20",
  strokeLinecap: "square",
  d: "M40.5.5l-40 35"
}));

var SvgHatIcon = function SvgHatIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHatIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hat_icon.1220e30e.svg";
export { ForwardRef as ReactComponent };